
<div class="content-main" [formGroup]="CustomFilter">
  <h4 class="popup-title">Filters</h4>
  <div class="transactionType">
    <label class="title">Status</label>
    <div class="f-row">
      <mat-checkbox class="checkbox-wrapper" formControlName="Active">Active</mat-checkbox> &nbsp;
      <mat-checkbox class="checkbox-wrapper" formControlName="Deactivated">Deactivated</mat-checkbox>
    </div>
  </div>
  <div class="transactionType" formGroupName="branches">
    <label class="title">Branch name</label>
    <div class="d-checkbox-3-grid">
      <ng-container *ngFor="let commonData of data.branchdata; let i = index" [formArrayName]="i">
        <mat-checkbox class="checkbox-wrapper" formControlName="checked" (change)="bindID('branches',i,commonData.ID,$event)"> {{ commonData.Name }} </mat-checkbox>
      </ng-container>
    </div>
  </div>
  <!-- <div class="transactionType" formGroupName="departments">
    <label class="title">Branch name</label>
    <div class="d-checkbox-3-grid">
      <ng-container *ngFor="let commonData of data.Departmentdata; let i = index" [formArrayName]="i">
        <mat-checkbox class="checkbox-wrapper" formControlName="checked" (change)="bindID('departments',i,commonData.ID,$event)"> {{ commonData.Name }} </mat-checkbox>
      </ng-container>
    </div>
  </div> -->
  <div class="button-wrapper">
    <button mat-button class="button--primary-small" (click)="applyFilters()">Apply</button>
  </div>
</div>
